import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BrnService, BrnServiceRequest } from '../../services/brn.service';

@Component({
  selector: 'app-oauth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.scss']
})
export class OauthComponent implements OnInit {
  loading = true;
  error = '';
  success = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private brnService: BrnService
  ) {}

  async ngOnInit() {
    // Get URL parameters
    this.route.queryParams.subscribe(async params => {
      const code = params['code'];
      const shop = params['shop'];
      const state = params['state']; // This contains the bot_id we passed during OAuth

      console.log(code);
      console.log(state);

      
      if (code && shop && state) {
        await this.handleOAuthCallback(code, shop, state);
      } else {
        this.error = 'Missing required OAuth parameters';
        this.loading = false;
      }
    });
  }

  private async handleOAuthCallback(code: string, shop: string, botId: string) {
    try {
      this.loading = true;
      this.error = '';

      // Prepare service data for BRN service creation
      const serviceData: BrnServiceRequest = {
        category: "ecommerce",
        data: {
          shop: shop,
          active: true,
          access_token: ''
        //  code: code
        }
      };

      // Create the service
      const response = await firstValueFrom(this.brnService.create(botId, serviceData));
      
      if (response.status) {
        this.success = true;
        try {
          // After Shopify OAuth connect, create import task for last 30 days ending yesterday
          const formatDate = (d: Date) => d.toISOString().slice(0, 10);
          const untilDate = new Date();
          untilDate.setDate(untilDate.getDate() - 1); // yesterday
          const sinceDate = new Date(untilDate);
          sinceDate.setDate(sinceDate.getDate() - 30); // 30 days before yesterday
          const since = formatDate(sinceDate);
          const until = formatDate(untilDate);
          await firstValueFrom(this.brnService.createImportTask(botId, 'shopify', since, until));
          console.log('Shopify import task created (OAuth)', { since, until });
        } catch (e) {
          console.error('Failed to create Shopify import task (OAuth)', e);
        }

        // Ensure daily store-health report is scheduled on connect
        try {
          await firstValueFrom(this.brnService.scheduleReportIfMissing(botId, 'store-health'));
          console.log('Ensured daily store-health report is scheduled (OAuth)');
        } catch (e) {
          console.error('Failed to ensure store-health report schedule (OAuth)', e);
        }

        // Redirect back to the store page after a short delay
        setTimeout(() => {
          this.router.navigate(['/store', botId]);
        }, 2000);
      } else {
        this.error = 'Failed to create Shopify service';
      }
    } catch (error: any) {
      console.error('OAuth callback error:', error);
      this.error = error.error?.error || 'Failed to complete Shopify connection';
    } finally {
      this.loading = false;
    }
  }

  goBackToStores() {
    this.router.navigate(['/stores']);
  }
} 